<img
  loading="lazy"
  [ngClass]="[variant, 'img-fluid']"
  [alt]="altText"
  [width]="width"
  [height]="height"
  [src]="image" />
